import React, { useEffect, useState } from "react";
import { PlusOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Modal as AntModal, Table, Space } from "antd";
import axios from "axios";
import Footer from "../../../components/Footer";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import { API_URL, TOKEN } from "../../../variables/constants";
import { toast } from "react-toastify";
import AddCauseSinistre from "./AddCauseSinistre";
import ActionDropdown from "../../production/components/ActionDropdown";

const CausesSinistres = () => {
  const [causesSinistre, setCausesSinistre] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedCauseSinistre, setSelectedCauseSinistre] = useState(null);

  useEffect(() => {
    fetchCauses();
  }, []);

  const fetchCauses = () => {
    axios
      .get(`${API_URL}/api/parametre/type/CAUSE_SINISTRE`, {
        headers: { Authorization: `Bearer ${TOKEN}` },
      })
      .then((res) => {
        const sorted = res.data.sort((a, b) => b.parametreId - a.parametreId);
        setCausesSinistre(sorted);
      })
      .catch((err) => console.error("Erreur de récupération:", err));
  };

  const handleShow = (edit = false, cause = null) => {
    setShowModal(true);
    setEditMode(edit);
    setSelectedCauseSinistre(cause);
  };

  const handleClose = () => {
    setShowModal(false);
    setEditMode(false);
    setSelectedCauseSinistre(null);
  };

  const handleAdd = (newItem) => {
    setCausesSinistre((prev) => [newItem, ...prev]);
  };

  const handleUpdate = (updatedItem) => {
    setCausesSinistre((prev) => {
      const filtered = prev.filter(
        (item) => item.parametreId !== updatedItem.parametreId
      );
      return [updatedItem, ...filtered];
    });
  };

  const handleDeleteCauseSinistre = (id) => {
    AntModal.confirm({
      title: "Êtes-vous sûr de vouloir supprimer cette cause de sinistre ?",
      content: "Cette action est irréversible",
      okText: "Oui",
      okType: "danger",
      cancelText: "Annuler",
      onOk: () => {
        axios
          .delete(`${API_URL}/api/parametre/${id}`, {
            headers: { Authorization: `Bearer ${TOKEN}` },
          })
          .then(() => {
            setCausesSinistre((prev) =>
              prev.filter((item) => item.parametreId !== id)
            );
            toast.success("Cause de sinistre supprimée avec succès.");
          })
          .catch((err) => {
            console.error("Erreur suppression:", err);
            toast.error("Erreur lors de la suppression.");
          });
      },
    });
  };

  const columns = [
    {
      title: "Libellé",
      dataIndex: "libelleParametre",
      key: "libelleParametre",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <ActionDropdown
          actions={[
            {
              key: "edit",
              label: "Modifier",
              icon: <i className="bx bx-edit-alt" />,
              onClick: () => handleShow(true, record),
            },
            {
              key: "delete",
              label: "Supprimer",
              icon: <i className="bx bx-trash" />,
              danger: true,
              onClick: () => handleDeleteCauseSinistre(record.parametreId),
            },
          ]}
        />
      ),
    },
  ];

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu="PARAMETRES_SINISTRES" />
        <div className="layout-page">
          <NavBar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                style={{ marginBottom: 16 }}
                onClick={() => handleShow()}
              >
                Ajouter une nouvelle cause de sinistre
              </Button>
              <div className="card">
                <h5 className="card-header">
                  Paramétrage des causes de sinistres
                </h5>
                <Table
                  columns={columns}
                  dataSource={causesSinistre}
                  rowKey="parametreId"
                  pagination={{ pageSize: 10 }}
                />
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

      <AddCauseSinistre
        show={showModal}
        handleClose={handleClose}
        editMode={editMode}
        selectedCauseSinistre={selectedCauseSinistre}
        causesSinistre={causesSinistre}
        onAdd={handleAdd}
        onUpdate={handleUpdate}
      />
    </div>
  );
};

export default CausesSinistres;
